import { environment } from "@/lib/environment"
import useStore from "@/store"
import createPosthog from "posthog-js"

export const posthog = createPosthog.init(environment.POSTHOG_KEY, {
  api_host: environment.POSTHOG_HOST,
  disable_persistence: true,
  capture_pageview: "history_change",
  before_send: [
    (event) => {
      if (!event) {
        return event
      }

      const store = useStore.getState()

      event.properties.appVersion = store.app.version

      if (event.event === "$exception") {
        const exceptionList = event.properties["$exception_list"] || []
        const exception = exceptionList.length > 0 ? exceptionList[0] : null

        if (exception) {
          event.properties["$exception_fingerprint"] =
            exception.value || exception.type
        }
      }

      if (environment.MODE === "development") {

        return null
      }

      return event
    },
  ],
})
